/**
 * @desc 更新报关信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.ProductDeclareInforequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productMaster/updateDeclareInfo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
